import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { selectAnalyticsVis } from "../../../features/layers/analyticsslice";
const Data = () => {
  const [featureInfo, setFeatureInfo] = useState({
    data: [],
    isFetching: false,
  });
  const [showLayer, setShowLayer] = useState(false);
  const [showLayer1, setShowLayer1] = useState(false);
  const [showLayer2, setShowLayer2] = useState(false);
  const [showLayer3, setShowLayer3] = useState(false);
  const [showLayer4, setShowLayer4] = useState(false);
  const [showLayer5, setShowLayer5] = useState(false);
  const [showLayer6, setShowLayer6] = useState(false);
  const [yes, setyes] = useState(false);
  const dispatch = useDispatch();
  const state = useSelector(selectAnalyticsVis);
  const getInfo = async () => {
    if(state.data.length > 0){
        setyes(true)
    }
  };
  useEffect(() => {
    getInfo();
  }, [state]);
  return (
    (
      <INFO>
        {
            yes && 
            (
                <React.Fragment >
                    <div className="InfoBox">
                    {/* {state.data.map((tab, index) => (
                        <div>
                            <p onClick={() => setShowLayer(!showLayer)}>
                                       {showLayer ? (
                                       <RemoveIcon />
                                       ) : (
                                       <AddIcon />
                                       )}
                             { tab.name}     
                            </p>
                           { tab.name==='Ground Water' ? 
                            <table className={`${showLayer ? "showtable" : "visibility"}`}>
                                <thead >
                                    <tr>
                                    <th scope="col">Ground Water Availability</th>
                                    <th scope="col">Area in Ha</th>
                                   
                                    </tr>
                            </thead>
                            {
                                JSON.parse(tab.data.maindata).map((tabs, indexs) => (
                                        <tbody >
                                            <tr>
                                            <td scope="col">{tabs.gwavailabi}</td> 
                                            <td scope="col">{Number(tabs.area_ha).toFixed(2)}</td> 
                                          
                                            </tr>
                                        </tbody>
                                ))}
                            </table> : ''
                          }
                           { tab.name==='Roads' || tab.name==='Settlement' ? 
                            <table className={`${showLayer ? "showtable" : "visibility"}`}>
                                <thead >
                                    <tr>
                                    <th scope="col">{tab.name}</th>
                                  
                                    </tr>
                            </thead>
                            {
                                JSON.parse(tab.data.maindata).map((tabs, indexs) => (
                                        <tbody >
                                            <tr>
                                            <td scope="col">{tabs.main}</td> 
                                          
                                            </tr>
                                        </tbody>
                                ))}
                            </table> : ''
                          }
                          { tab.name==='Mulberry Suitability' ||  tab.name==='Non Mulberry Suitability' ? 
                            <table className={`${showLayer ? "showtable" : "visibility"}`}>
                                <thead >
                                    <tr>
                                    <th scope="col">Suitability</th>
                                    <th scope="col">Area in Ha</th>
                                    
                                    </tr>
                            </thead>
                            {
                                JSON.parse(tab.data.maindata).map((tabs, indexs) => (
                                        <tbody >
                                            <tr>
                                            <td scope="col">{tabs.suitabilit}</td> 
                                            <td scope="col">{Number(tabs.area_ha).toFixed(2)}</td> 
                                           
                                            </tr>
                                        </tbody>
                                ))}
                            </table> : ''
                          }
                          { tab.name==='Soil Texture' ||  tab.name==='Soil Depth' ||  tab.name==='Soil Erosion' ||  tab.name==='Soil Erosion' ||  tab.name==='Soil Drain' ||  tab.name==='Soil PH'  ? 
                            <table className={`${showLayer ? "showtable" : "visibility"}`}>
                                <thead >
                                    <tr>
                                    <th scope="col">{tab.name}</th>
                                    <th scope="col">Area in Ha</th>
                                   
                                    </tr>
                            </thead>
                            {
                                JSON.parse(tab.data.maindata).map((tabs, indexs) => (
                                        <tbody >
                                            <tr>
                                            <td scope="col">{tabs.main}</td> 
                                            <td scope="col">{Number(tabs.area_ha).toFixed(2)}</td> 
                                           
                                            </tr>
                                        </tbody>
                                ))}
                            </table> : ''
                          }
                        </div>
                    ))}  */}
                   </div>
                </React.Fragment>
            )
            }
      </INFO>
    )
  );
};

export default Data;

export const INFO = styled.div`
  p {
    align-items: center;
    width: 100%;
    padding: 10px 10px;
    margin-bottom: 0px;
    background: #38a3a2;
    color: #fff;
    border-bottom: 1px solid #fff;
  }
  p > .MuiSvgIcon-root {
    float: left;
    color: #fff;
  }
  .visibility {
    display: none;
  }
 
`;
